import { Typography, TextField } from '@mui/material';
import { height, maxWidth, styled } from "@mui/system";


// 共通入力フィールド
export const BaseInputField = styled(TextField)(({ theme }) =>({
    "& .MuiInputBase-root": {
        width: '140%',
        height: 'auto'
      },
}))


// 入力内容を右端に寄せる
export const RightAlignInputField = styled(TextField)(() => ({
    "& .MuiInputBase-input": {
        textAlign: "right",
      },
      "& .MuiInputBase-root": {
        width: '100%',
      }
}))

